import React from 'react';
import {Route, Redirect} from 'react-router-dom';
import LinkAccountGate from '../LinkAccount/LinkAccountGate';

/**
 * Ruta privada: exige sesión del socio (localStorage.user) y, en la ventana de mudanza a la
 * cuenta nueva de PowerGym, pasa por LinkAccountGate (bloquea hasta que la cree).
 */
const PrivateRoute = ({component: Component, ...rest}) => (
    <Route {...rest} render={props => (
            localStorage.getItem('user')
            ? <LinkAccountGate><Component {...props} /></LinkAccountGate>
            : <Redirect to={{pathname: '/login', state: {from: props.location}}}/>
    )}/>
);

export default PrivateRoute;
